<template>
  <div class="insights-team-collaboration-pill">
    <label>{{ label }}</label>
    <div class="collaboration-pill">
      <i class="pill-icon material-symbols-rounded">{{ icon }}</i>
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
import { formatDuration } from '~/utils/time_utils';
import { numericValue } from '~/utils/insights_utils';
import { INSIGHTS } from '~/app_constants';

export default {
  name: 'InsightsTeamCollaborationPill',
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    property: {
      type: String,
      required: true,
    },
  },
  computed: {
    text() {
      return this.property.includes('duration')
        ? formatDuration(this.value, { showSeconds: true })
        : numericValue(this.value);
    },
    icon() {
      return INSIGHTS.collaborations.icons[this.type][this.property] || 'info';
    },
    label() {
      return INSIGHTS.collaborations.labels[this.type][this.property];
    },
  },
};
</script>
